export const lengthUnit = [
  { value: 'in', label: 'inches' },
  { value: 'mm', label: 'millimeter' },
]

export const weightUnit = [
  { value: 'oz', label: 'ounce' },
  { value: 'lbs', label: 'pounds' },
  { value: 'g', label: 'gram' },
  { value: 'kg', label: 'kilogram' },
]

export const angleUnit = [{ value: 'deg', label: 'degrees' }]
